export function applyTransformations(vertex, transforms) {
    let v = vertex.clone();
    transforms.forEach((m, i) => {
        v.transformMat4(m);
    });
    return v;
}
